<template>
  <div class="data-management">
    <v-row no-gutters class="pr-0 mb-2">
      <v-col cols="12" class="pt-4">
        <div class="well-top-wrap">
          <h6>Samples</h6>
          <div class="expand-all-checkbox">
            <input type="checkbox" v-model="expandAllSamples" @change="toggleExpandAll" />
            <span>Expand All Samples</span>
          </div>
        </div>
        <TabularLoaders v-if="showLoader" />
        <v-table v-else-if="samples.length > 0" class="well-table sample-table">
          <thead>
            <tr class="main-header">
              <th>Sample ID</th>
              <th>Sample Type</th>
              <th class="text-center">Expand/Collapse</th>
            </tr>
          </thead>
          <tbody class="well-table-content">
            <template v-for="(sample, index) in samples" :key="index">
              <tr :style="getRowStyle(sample)" class="cursor-pointer">
                <td :style="getCellStyle(sample)">
                  <span class="clickable-cell no-bg" @click="goToSampleInformation(sample)">{{ sample.fluidSampleID }}</span>
                </td>
                <td :style="getCellStyle(sample)">{{ sample.sampleType }}</td>
                <td :style="getCellStyle(sample)">
                  <div class="expand-collapse-icon wells-expand-toggle" @click.stop="sample.expanded = !sample.expanded">
                    <img
                      :src="sample.expanded ? up : down"
                      alt=""
                      class="cursor-pointer wells-expand-arrow"
                      width="14"
                      height="9"
                    />
                  </div>
                </td>
              </tr>
              <tr v-if="sample.expanded" class="expanded-tr">
                <td colspan="3" class="sample-expanded-div pt-2">
                  <div v-if="sampleHasTests(sample)" class="d-flex align-center justify-space-between">
                    <div class="sample-test-wrapper">
                    <div v-for="(item, itemIndex) in comparisonArray" :key="item" class="sub-test-wrap" :style="{ marginRight: sample[item] !== undefined ? '8px' : '0px', marginTop: sample[item] !== undefined ? '4px' : '0px', marginBottom: sample[item] !== undefined ? '4px' : '0px' }">
                      <template v-if="sample[item] !== undefined">
                        <template v-if="Array.isArray(sample[item])">
                          <div v-for="(test, testIndex) in sample[item]" :key="`${testIndex}-${itemIndex}`"
                            class="well-content sample-content " 
                            @click="openTestPage(sample, item, testIndex, itemIndex)"
                           >
                            <div class="sample-test-div">
                              <img :src="test_image" alt="Panel Image" />
                            </div>
                            {{ displayTestType(item) }}
                            <template v-if="item === 'compositiontests'">
                              <span v-if="test.contaminationType === 'Physical'">
                                (Physical)
                              </span>
                              <span v-else-if="test.contaminationType === 'Mathematical'">
                                (Mathematical)
                              </span>
                              <span v-else-if="test.contaminationType">
                                (Contaminated)
                              </span>
                              <span v-else-if="test.recombinationType">
                                (Uncontaminated)
                              </span>
                            </template>
                            <span v-if="sample[item].length > 1" class="test-temperature">
                              (Test # {{ testIndex + 1 }})
                            </span>
                            <span class="test-temperature" v-if="test.testTemperature || test.testTemperature_UOM">
                              ({{ test.testTemperature }} {{ test.testTemperature_UOM }})
                            </span>
                          </div>
                        </template>
                        <div v-else class="well-content sample-content" 
                          @click="openTestPage(sample, item, itemIndex)">
                          <div class="sample-test-div">
                            <img :src="test_image" alt="Panel Image" class="mr-2" width="20" height="20" />
                          </div>
                          {{ displayTestType(item) }}
                          <template v-if="item === 'compositiontests'">
                            <span v-if="sample[item].contaminationType === 'Physical'">
                              (Physical)
                            </span>
                            <span v-else-if="sample[item].contaminationType === 'Mathematical'">
                              (Mathematical)
                            </span>
                            <span v-else-if="sample[item].contaminationType">
                              (Contaminated)
                            </span>
                            <span v-else-if="sample[item].recombinationType">
                              (Uncontaminated)
                            </span>
                          </template>
                          <span class="test-temperature"
                            v-if="sample[item].testTemperature && sample[item].testTemperature_UOM">
                            ({{ sample[item].testTemperature }} {{ sample[item].testTemperature_UOM }})
                          </span>
                        </div>
                      </template>
                    </div>
                    </div>
                    <div>
                      <div v-if="pdfLoaders[sample.ID]" class="pdf-div">
                        <img :src="pdf_loader_image" alt="loader Image" width="20" height="20" />
                      </div>
                      <div v-else @click="goToPdf(sample)" class="pdf-btn">
                          <img :src="pdf_icon" alt="pdf icon" />
                      </div>
                    </div>
                  </div>
                  <div v-else class="loader-div justify-start pl-3">
                    No test found.
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </v-table>
        <div v-else-if="timeoutMessage != ''" class="no-asset-div timeout">
          <div class="text-center">
            {{ timeoutMessage }}
            <v-icon flat @click="fetchData()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
          </div>
        </div>
        <div class="no-asset-div" v-else-if="samples.length == 0 && showLoader == false && timeoutMessage == ''
        ">
          <h4>No sample(s) founds.</h4>
        </div>
      </v-col>
    </v-row>
    <ErrorPopup />
    <v-snackbar v-model="snackbarMessage" :color="snackbarColor" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import api from "../../../axiosInterceptor"
import { blobFromSampleReportResponse } from "../../../utils/sampleReportDownload";
import { getTenantPrefix } from "../../../utils/tenant";
import TabularLoaders from "../Loaders/TabularLoaders.vue";
import { mapActions } from "vuex";
import ErrorPopup from '../Popups/ErrorPopup.vue';

export default {
  name: "Sample",
  components: {
    TabularLoaders,
    ErrorPopup,
  },
  data() {
    return {
      samples: [],
      sampleIdString:'',
      up: require("../../../assets/Images/Buttons/arrow-up.svg"),
      down: require("../../../assets/Images/Buttons/arrow_down.svg"),
      sample_image: require("../../../assets/Images/Assets/wells.png"),
      test_image: require("../../../assets/Images/Assets/sample.png"),
      pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
      pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
      allTests: [],
      loader: true,
      openPanelIndex: null,
      showLoader: true,
      showAllSamples: false,
      pdfLoaders: {},
      snackbarMessage: null,
      expandedPanels: [],
      selectedSampleID: null,
      comparisonArray: [
        "compositiontests",
        "ccetests",
        "dltests",
        "cvdtests",
        "separatortests",
        "viscositytests",
      ],
      expandAllSamples: true,
      timeoutMessage: "",
    };
  },
  computed: {
    displayTestType() {
      return function (testType) {
        switch (testType) {
          case "compositiontests":
            return "Composition";
          case "ccetests":
            return "CCE Test";
          case "dltests":
            return "DL Test";
          case "cvdtests":
            return "CVD Test";
          case "separatortests":
            return "Separator Test";
          case "viscositytests":
            return "Viscosity Test";
          default:
            return testType;
        }
      };
    },
    filteredComparisonArray() {
      return this.comparisonArray?.filter(item => 
        this.sample[item] && (
          Array.isArray(this.sample[item]) ? this.sample[item].length > 0 : true
        )
      );
    },
    getRowStyle() {
      return (sample) => ({
        background: sample.expanded 
          ? (this.$store.getters["darkMode/isDarkMode"] ? '#ffffff08' : '#00000008')
          : (this.$store.getters["darkMode/isDarkMode"] ? '#1f2937' : '#FFFFFF')
      });
    },
    getCellStyle() {
      return (sample) => ({
        borderBottom: sample.expanded 
          ? 'none' 
          : `1px solid ${this.$store.getters["darkMode/isDarkMode"] ? '#374151' : '#E0E0E0'}`
      });
    },
    snackbarColor() {
      return this.$store.getters["darkMode/isDarkMode"] ? '#ef4444' : '#E53535';
    },

  },
  methods: {
    ...mapActions("test", ["setActiveTestIndex"]),
    ...mapActions("api", ["showSnackbar"]),
    fetchData(wellName,sampleId) {
      this.showLoader = true;
      this.timeoutMessage = "";
      const wellString = JSON.stringify(wellName);
      this.sampleIdString = JSON.stringify(sampleId);

      api
        .get(`public/api/samples`, {
          params: {
            well: wellString,
            viewSummary: true,
            id:this.sampleIdString
          },
        })
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            if (this.showAllSamples) {
              this.samples = response.data.data.samples;
              this.samples.forEach((sample) => {
                sample.expanded = true; // Set expanded property to true
              });
            } else {
              this.samples = response.data.data.samples?.filter(
                (sample) => sample.IsTestAvailable
              );
              this.samples.forEach((sample) => {
                sample.expanded = true; // Set expanded property to true
              });
            }
          }
          else if (response && response.data && response.data.message) {
        this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching samples";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },
    sampleHasTests(sample) {
      return sample.IsTestAvailable;
    },
    toggleExpandAll() {
      this.samples.forEach((sample) => {
        sample.expanded = this.expandAllSamples;
      });
    },
    expandAll() {
      this.expandedPanels = this.samples.map((sample) => sample.ID);
    },
    collapseAll() {
      this.expandedPanels = [];
    },
    showTests(sample) {
      this.loader = true;
      const sampleId = sample.ID;
      api
        .get(
          `public/api/samples/${sampleId}/tests`
        )
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.loader = false;
            this.allTests = response.data.data.allTests;
          }
          else if (response && response.data && response.data.message) {
        this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching tests";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },
    openTestPage(sample, item, index) {
      const filteredComparisonArray = this.comparisonArray?.filter(
        (comparisonItem) => sample.hasOwnProperty(comparisonItem)
      );

      let cumulativeIndex = 0;
      let itemIndex = -1;
      for (let i = 0; i < filteredComparisonArray.length; i++) {
        if (filteredComparisonArray[i] === item) {
          itemIndex = cumulativeIndex;
          break;
        }
        if (Array.isArray(sample[filteredComparisonArray[i]])) {
          cumulativeIndex += sample[filteredComparisonArray[i]].length;
        } else {
          cumulativeIndex++;
        }
      }

      this.setActiveTestIndex(itemIndex);
      const mongoSampleId = sample.ID;
      let testType = "";
      if (item != "compositiontests") {
         testType = item.endsWith("s") ? item.slice(0, -1) : item;
      }else{
         testType = item;
      }
      let testId;
      if (Array.isArray(sample[item])) {
        testId = sample[item][index].ID;
      } else {
        testId = sample[item].ID;
      }
      const tenant = getTenantPrefix();
      const asset = this.$route.params.asset;
      const field = this.$route.params.field;
      const well = this.$route.params.well;
      if (!tenant || !asset || !field || !well || !mongoSampleId || !testId) return;
      const encodeSeg = (v) => (v ? encodeURIComponent(v).replace(/'/g, "%27").replace(/ /g, "-") : "");
      const newRoute = `/${tenant}/assets/${encodeSeg(asset)}/${encodeSeg(field)}/${encodeSeg(well)}/${encodeSeg(mongoSampleId)}/${testType}/${testId}`;
      localStorage.setItem("lastView", newRoute);
      this.$router.push(newRoute);
      
    },
    reportExtensionFromSample(sample) {
      const s = sample?.source;
      if (!s || typeof s !== "string" || s === "Synthetic Data" || !s.includes(".")) {
        return "pdf";
      }
      const lower = s.toLowerCase();
      if (lower.endsWith(".xlsm")) return "xlsm";
      if (lower.endsWith(".xlsx")) return "xlsx";
      if (lower.endsWith(".xls")) return "xls";
      if (lower.endsWith(".pdf")) return "pdf";
      return "pdf";
    },
    goToPdf(sample) {
      this.snackbarMessage = null;
      this.pdfLoaders[sample.ID] = true;
      const sampleId = sample.ID;
      const ext = this.reportExtensionFromSample(sample);
      api
        .get(`public/api/samples/${sampleId}/download`, {
          responseType: "blob",
        })
        .then(async (response) => {
          const result = await blobFromSampleReportResponse(response, ext);
          this.pdfLoaders[sample.ID] = false;
          if (!result.ok) {
            this.snackbarMessage = result.message;
            return;
          }
          const url = URL.createObjectURL(result.blob);
          window.open(url, "_blank");
        })
        .catch(async (error) => {
          this.pdfLoaders[sample.ID] = false;
          const fallbackDownloadError = `Failed to download ${ext.toUpperCase()} report.`;
          const data = error.response?.data;
          if (data instanceof Blob) {
            try {
              const text = await data.text();
              const j = JSON.parse(text);
              if (j && Number(j.statusCode) >= 500) {
                this.snackbarMessage = fallbackDownloadError;
                return;
              }
              if (j && j.message) {
                this.snackbarMessage = j.message;
                return;
              }
            } catch (_) {
              /* fall through */
            }
          }
          if (error?.response) {
            if (Number(error.response.status) >= 500) {
              this.snackbarMessage = fallbackDownloadError;
              return;
            }
            this.snackbarMessage =
              "The PDF report is not available for synthetic data in this study/sample/test. Please explore tests/samples under Asset: Public Data to check the power of this feature.";
          } else {
            this.snackbarMessage = "Error: Network or server issue.";
          }
        });
    },

    goToSampleInformation(sample) {
      const tenant = getTenantPrefix();
      const asset = this.$route.params.asset;
      const field = this.$route.params.field;
      const well = this.$route.params.well;
      const sampleId = sample.ID;
      if (!tenant || !asset || !field || !well || !sampleId) return;
      const encodeSeg = (v) => (v ? encodeURIComponent(v).replace(/'/g, "%27").replace(/ /g, "-") : "");
      const newRoute = `/${tenant}/assets/${encodeSeg(asset)}/${encodeSeg(field)}/${encodeSeg(well)}/sampleinformation/${encodeSeg(sampleId)}`;
      localStorage.setItem("lastView", newRoute);
      this.$router.push(newRoute);
    },
  },
  watch: {
    $route(to, from) {
      this.fetchData(to.params.well,to.params.sampleId);
    },
    showAllSamples(value) {
      this.fetchData(this.$route.params.well,this.$route.params.sampleId);
    },
    expandAllSamples() {
      if (this.expandAllSamples) {
        this.expandAll();
      } else {
        this.collapseAll();
      }
    },
  },
  mounted() {
    this.fetchData(this.$route.params.well,this.$route.params.sampleId);
  },
};
</script>

<style scoped>
.wells-expand-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wells-expand-arrow {
  display: block;
  width: 14px;
  height: 9px;
  object-fit: contain;
}
</style>
